import * as React from 'react'
import { FC } from 'react'

import CardContent from '@mui/material/CardContent'
import { Theme } from '@mui/material/styles'

const styles = {
  root: {
    '&:last-child': {
      paddingBottom: (theme: Theme) => theme.spacing(1.5),
    },
  },
}

interface Props {
  children?: JSX.Element
  className?: string
}

export const WidgetBody: FC<Props> = (props) => {
  return <CardContent sx={styles.root}>{props.children}</CardContent>
}

WidgetBody.displayName = 'WidgetBody'
